/*
 * Copyright (c) Nexign, JSC, 2020-2022.
 */
/**
 * Styled components for SettingsAutoReports
 *
 * @author Anton Panasenko
 * @author Ilya Babanov
 * @version 1.22.0
 * @since 1.3.0
 */

import styled from 'styled-components';

export const SettingsAutoReportsContainerStyled = styled.div`
    padding: 24px;
`;


export const SettingsAutoReportsLinkContainerStyled = styled.div`
    display: flex;
`;

export const SettingsAutoReportsLinkTitleStyled = styled.div`
    margin-right: 0.3em;
`;
